/**
 * Enrich profession rows with Vision ticker metadata and sort like Student CareerScreen.
 */
export function prepareCareersWithVision(professions = [], careerVisionById = {}) {
	if (!professions?.length) return []

	const enriched = professions.map((item, index) => {
		const visionMeta = careerVisionById[item.profession_id] || {}
		return {
			...item,
			_originalIndex: index,
			countriesVision: visionMeta.topCountries || [],
			withHomeCountry: Boolean(visionMeta.withHomeCountry),
			maxVisionScore: visionMeta.maxTopScore,
		}
	})

	const candidates = enriched
		.filter(item => item.countriesVision?.length)
		.sort((a, b) => {
			if (a.withHomeCountry && !b.withHomeCountry) return -1
			if (!a.withHomeCountry && b.withHomeCountry) return 1
			if (b.maxVisionScore !== a.maxVisionScore) {
				return b.maxVisionScore - a.maxVisionScore
			}
			return a._originalIndex - b._originalIndex
		})
		.slice(0, 3)

	const topIdSet = new Set(candidates.map(item => item.profession_id))
	const topIndexById = new Map(
		candidates.map((item, idx) => [item.profession_id, idx]),
	)

	return enriched
		.map(item => ({
			...item,
			isVisionTop: topIdSet.has(item.profession_id),
			visionPriority: topIndexById.has(item.profession_id)
				? topIndexById.get(item.profession_id)
				: null,
		}))
		.sort((a, b) => {
			if (a.isVisionTop && !b.isVisionTop) return -1
			if (!a.isVisionTop && b.isVisionTop) return 1
			if (a.isVisionTop && b.isVisionTop) return a.visionPriority - b.visionPriority
			return a._originalIndex - b._originalIndex
		})
}
